import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { TableKeepers } from "./components/TableKeepers";
import { CatalogKeeper } from "@/shared/models/CatalogKeeper";
import { getCatalogKeepers } from "@/shared/repositories/CatalogKeeperRepository";

type useCatalogKeepersProps = {
	onError?: (error: Error) => void;
};

export const useCatalogKeepers = ({ onError }: useCatalogKeepersProps) => {
	return useQuery<CatalogKeeper[], Error>({
		queryKey: ["catalogKeepers"],
		queryFn: () => getCatalogKeepers(),
		onError: onError,
	});
};

export const CatalogKeepersPage = () => {
	return (
		<>
			<HelmetDexteel title="Keepers - Configurations" />
			<TableKeepers />
		</>
	);
};
